export const SET_COMPANY_LOADING = 'SET_COMPANY_LOADING'
export const SET_COMPANY = 'SET_COMPANY'
export const ADD_COMPANY = 'ADD_COMPANY'
export const EDIT_COMPANY = 'EDIT_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'